<scareddit-header></scareddit-header>
<main role="main">
  <router-outlet></router-outlet>
</main>
<scareddit-scroll-to-top [showComponent]="showScrollToTopComponent"></scareddit-scroll-to-top>
<scareddit-footer></scareddit-footer>
